import {$, w} from './constants';
import './click-handler.js';

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');

    setTimeout( () => {
        $('#modal-popup').addClass('show-popup');
    }, 500);
    if($('#modal-popup').length){
        //Links en modal
        const links = $('#modal-popup').find('a');
        Array.from(links).forEach(a => {
            a.addEventListener('click', e => {
               getSamePageAnchor(a);
            });
        });
    }
    if($('.pedidos__info-container').length){
        //Links en modal
        const links = $('.pedidos__info-container').find('a');
        Array.from(links).forEach(a => {
            a.addEventListener('click', e => {
               getSamePageAnchor(a);
            });
        });
    }
});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');
    //sessionStorage.setItem('show-banner', false);
})

 // Revisamos sí en link es uno en la misma página o sí es externo
 function getSamePageAnchor (link) {
    if (
        link.protocol !== window.location.protocol ||
        link.host !== window.location.host ||
        link.pathname !== window.location.pathname ||
        link.search !== window.location.search
    ) {
        link.target = "_blank";
    }
}



// WEBPACK FOOTER //
// ./es6/micorriza.js